import {
    ProductWithAddOns,
    SelectedPacket
} from 'components/enrollForm/enrollFormTypes'
import { getDiscountsForPackageId } from './buildRegisteredPackageRows'
import { getOwnedPackageCount } from './getOwnedPackageCount'
import { getPackageDiscountAllocation } from './packageDiscountMath'
import { Order } from 'storeTypes'

export type OptimisticDiscountAssignment = {
    discount_per_package: number
    /** Net unit charge (list − discount_per_package). */
    price: number
}

/**
 * Per-cart-row net price and discount_per_package, aligned with core's
 * capped allocation (first discountedCartUnits rows get the tier; rest stay list).
 * Order matches `packets` indices.
 */
export const assignOptimisticPackageDiscounts = (
    packets: SelectedPacket[] = [],
    fullGoalItems: Order[] = [],
    products: ProductWithAddOns[] = []
): OptimisticDiscountAssignment[] => {
    const assignments: OptimisticDiscountAssignment[] = packets.map(
        (packet) => ({
            discount_per_package: 0,
            price: Number(packet.price) || 0
        })
    )

    const indicesByPackage = new Map<string, number[]>()
    packets.forEach((packet, index) => {
        const packageId = packet.package_id
        if (!packageId) {
            return
        }
        const indices = indicesByPackage.get(packageId) || []
        indices.push(index)
        indicesByPackage.set(packageId, indices)
    })

    indicesByPackage.forEach((indices, packageId) => {
        const owned = getOwnedPackageCount(packageId, { fullGoalItems })
        const discounts = getDiscountsForPackageId(packageId, products)
        const { discountPerPackage: tierDiscount, discountedCartUnits } =
            getPackageDiscountAllocation(discounts, indices.length, owned)

        indices.forEach((packetIndex, cartIndex) => {
            const listPrice = Number(packets[packetIndex].price) || 0
            const discountPerPackage =
                cartIndex < discountedCartUnits ? tierDiscount : 0
            assignments[packetIndex] = {
                discount_per_package: discountPerPackage,
                price: listPrice - discountPerPackage
            }
        })
    })

    return assignments
}
